import React from 'react';
import './header.css';

const Header = ({ activeSection, onNavClick, onRandom, jamsPage = 2, talksPage = 6 }) => {
    const sections = [
        { label: 'Games', page: 0 },
        { label: 'Game Jams', page: jamsPage },
        { label: 'Talks', page: talksPage },
    ];
    return (
    <div className="site-header">
        <nav className="site-header__nav">
            {sections.map(({ label, page }) => (
                <button
                    key={label}
                    className={`nav-btn${activeSection === label ? ' nav-btn--active' : ''}`}
                    aria-current={activeSection === label ? 'page' : undefined}
                    onClick={() => onNavClick(page, label)}
                >
                    {label}
                </button>
            ))}
            <button className="nav-btn nav-btn--random" onClick={onRandom}>
                Random
            </button>
        </nav>
    </div>
    );
};

export default Header;
